import * as api from 'api';
import { Item } from 'schema';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import { clientContext } from 'context';
import { prettyString, scheduleString, getPlainText, momentDate } from 'utils';
import moment from 'moment-timezone';
import _ from 'lodash';

//////////////
// HANDLERS //
//////////////
export const popupCenter = ({url, title, w, h}) => {
    // Fixes dual-screen position                             Most browsers      Firefox
    const dualScreenLeft = window.screenLeft !==  undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !==  undefined   ? window.screenTop  : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft
    const top = (height - h) / 2 / systemZoom + dualScreenTop
    const newWindow = window.open(url, title, 
        `
        scrollbars=yes,
        width=${w / systemZoom}, 
        height=${h / systemZoom}, 
        top=${top}, 
        left=${left}
        `
    )

    if (window.focus) newWindow.focus();
}

export const genAuthURL = async (app, uid) => {
    console.log('[genAuthURL]', {app: app, uid: uid})
    return await api.getAuthURL(app.toUpperCase(), {userId: uid})
    .then(res => {
        console.log('[genAuthURL] Completed', res.data)
        popupCenter({url: res.data['url'], title: 'xtf', w: 450, h: 600})
        return { success: true, data: res.data }
    })
    .catch(err => {
        console.log('[genAuthURL] Failed', err)
        return { success: false }
    })
}

export const validateWorkflow = (workflow, userId, triggerOnly) => {
    let outcome = true;
    let errors = { action: { ext: {} }, trigger: { ext: {} }}
    const oldWorkflow = {...workflow}
    let updatedWorkflow = {...workflow}
    updatedWorkflow['userId'] = userId
    const direction = updatedWorkflow['direction']
    // console.log('[validateWorkflow]', workflow)

    // Update Atomicly
    if(updatedWorkflow['direction'] === 'INFLOW'){
        updatedWorkflow['action'] = {...updatedWorkflow['action'], client: 'ATOMICLY', action: 'CreateItem', clientId: userId}
    } else if (updatedWorkflow['direction'] === 'OUTFLOW'){

    }

    // Basic validation
    const isValid = [
        updatedWorkflow.workflowTitle,
        updatedWorkflow.userId,
        updatedWorkflow.trigger['trigger'],
        updatedWorkflow.trigger['clientId'],
        updatedWorkflow.trigger['client'],
        !triggerOnly && updatedWorkflow.action['action'],
        !triggerOnly && updatedWorkflow.action['clientId'],
        !triggerOnly && updatedWorkflow.action['client'],
        direction === 'OUTFLOW' && updatedWorkflow.trigger.ext['pageID'],
        direction === 'OUTFLOW' && updatedWorkflow.trigger.ext['sectionID'],
        direction === 'OUTFLOW' && updatedWorkflow.trigger['trigger'] === 'LabelItem' && updatedWorkflow.trigger.ext['tags'],
        direction === 'OUTFLOW' && updatedWorkflow.trigger['trigger'] === 'PriorityItem' && updatedWorkflow.trigger.ext['priority'],

    ].every(x => (x !== null & x !== undefined))

    if(!isValid){
        outcome = false
        errors = {
            workflowtitle: !updatedWorkflow.workflowTitle && 'Required',
            trigger: {
                trigger: !updatedWorkflow.trigger['trigger'] && 'Required',
                clientId: !updatedWorkflow.trigger['clientId'] && 'Required',
                client: !updatedWorkflow.trigger['client'] && 'Required',
                ext: {
                    pageID: direction === 'OUTFLOW' && 
                            !updatedWorkflow.trigger.ext['pageID'] && 'Required',
                    sectionID: direction === 'OUTFLOW' && 
                            !updatedWorkflow.trigger.ext['sectionID'] && 'Required',
                    tags: direction === 'OUTFLOW' && 
                            updatedWorkflow.trigger['trigger'] === 'LabelItem' && 
                            !updatedWorkflow.trigger.ext['tags'] && 'Required',
                    priority: direction === 'OUTFLOW' && 
                            updatedWorkflow.trigger['trigger'] === 'PriorityItem' && 
                            !updatedWorkflow.trigger.ext['priority'] && 'Required',
                }
            },
            action: triggerOnly ? { ext: {} } : {
                action: !updatedWorkflow.action['action'] && 'Required',
                clientId: !updatedWorkflow.action['clientId'] && 'Required',
                client: !updatedWorkflow.action['client'] && 'Required',
                ext: {}
            }

        }
    }

    // Additional fields
    const sections = triggerOnly ? ['trigger'] : ['trigger', 'action']
    sections.map(section => {
        const client = updatedWorkflow[section]['client']
        const configs = clientContext[client] && clientContext[client]['configurations']

        // Base validation
        configs && Object.keys(configs).map(key => {
            const config = configs[key]
            const validation = config['required'] && typeof config['pre_requisite'] === 'function' && config['pre_requisite']({old: oldWorkflow, new: updatedWorkflow})
            if(validation && validation['isValid']){
                if(updatedWorkflow[section].ext ? !updatedWorkflow[section].ext[key] : true){
                    outcome = false
                    errors[section]['ext'][key] = 'Required'
                }
            }
        })

        // Client specific validation
        const clientValidationHandler = clientContext[client] && clientContext[client]['validation']
        if(clientValidationHandler && typeof clientValidationHandler === 'function'){
            const clientValidation = clientValidationHandler({workflow: workflow, userId: userId})
            // console.log(clientValidation)
            if(clientValidation && !clientValidation['isValid']){
                outcome = false
                errors[section]['ext'][clientValidation['key']] = clientValidation['error']
            }
        }
    })

    // Atomicly fields
    if(updatedWorkflow['direction'] === 'INFLOW' && !triggerOnly){
        ['title', 'pageID', 'sectionID'].map(field => {
            if(!updatedWorkflow.action.ext[field]){
                outcome = false
                errors['action']['ext'][field] = 'Required'
            }
        })
    }

    // console.log('[validateWorkflow]', { outcome: outcome, workflow: updatedWorkflow, errors: errors })
    return { outcome: outcome, workflow: updatedWorkflow, errors: errors }
}

const generateRandomKey = () => {
    const MULTIPLIER = Math.pow(2, 24);
    return Math.floor(Math.random() * MULTIPLIER).toString(32);
}

const constructRichText = (text) => {
    let blocks = text.split('\n')
    let textBlocks = blocks.map(block => (JSON.stringify({
        key: generateRandomKey(),
        text: block,
        type: 'unstyled',
        depth: 0,
        inlinestyleRanges: [],
        entityRanges: [],
        data: []
    })))
    return `{"blocks": [${textBlocks}], "entityMap": {}}`
}

/////////////////////
// GOOGLE CALENDAR //
/////////////////////
export const getGoogleCalendars = async (payload) => {
    const debug = false
    debug && console.log('[getGoogleCalendars] payload', payload)

    const userId = payload['userId']
    const clientId = payload.trigger['clientId']
    const body = { userId: userId, clientId: clientId}
    return await api.getGoogleCalendars(body)
    .then(res => {
        const calendars = res.data['calendars']
        let options = {} 
        calendars.map(calendar => {
            options[calendar['id']] = { title: calendar['summary'], value: calendar['id'] }
        })
        debug && console.log('[getGoogleCalendars] Completed', options)
        return { success: true, options: options }
    })
    .catch(err => {
        console.log('[getGoogleCalenders] Failed', err)
        return { success: false, options: {} }
    })
}

export const getGoogleCalendarEvents = async (payload) => {
    console.log('[getGoogleCalendarEvents] payload', payload)
    const userId = payload['userId']
    const clientId = payload.workflow.trigger['clientId']
    const calendarId = payload.workflow.trigger.ext['calendarId']
    const n = payload['n'] || 5
    const workflow = payload.workflow
    const trigger = workflow['trigger']['trigger']

    const body = { userId: userId, clientId: clientId, calendarId: calendarId, n: n } // [TODO] Add filters based on workflow options

    return await api.getGoogleCalendarEvents(body)
    .then(res => {
        // Convert event into items
        const events = res.data.events['items']
        let items = [];
        console.log('[All events]', events, trigger)
        // Filter events based on workflow config
        events.map(event => {
            const item = new Item({
                sectionID: workflow['action'].ext['sectionID'],
                pageID: workflow['action'].ext['pageID'],
                tags: workflow['action'].ext['tags'],
                priority: workflow['action'].ext['priority'],
                content: JSON.stringify(convertToRaw(ContentState.createFromText(event[workflow['action'].ext['title']]))),
                client: 'GOOGLE_CALENDAR',
                clientTitle: workflow.trigger.clientId
                // No need notes because its not being shown in the preview
            })
            const isMatch = workflow['trigger'].ext['match'] && event['summary'].includes(workflow['trigger'].ext['match'])
            const isAccepted = event['attendees'] && event['attendees'].some((e) => e['email'] === workflow.trigger['clientId'] && e['responseStatus'] === 'accepted')
            // console.log(isMatch, {workflow: workflow, event: event})
            switch(trigger){
                case 'NewEvent':
                    // Do nothing
                    items.push(item)
                    break
                case 'NewEventMatch':
                    // First event that matches
                    isMatch && items.push(item)
                    break
                case 'AcceptedEvent':
                    // First accepted event
                    isAccepted && items.push(item)
                    break
                case 'AcceptedEventMatch':
                    // First accepted event that matches
                    isMatch & isAccepted && items.push(item)
                    break
            }
        })
        console.log('[getGoogleCalendarEvents]', {events, items})
        return { success: items.length > 0, events: events, items: items }
    })
    .catch(err => {
        return { success: false, events: [], items: [] }
    })

}

///////////
// GMAIL //
///////////
export const getGmailLabels = async (payload) => {
    console.log('[getGmailLabels] payload', payload)

    const userId = payload['userId']
    const clientId = payload.trigger['clientId']
    const body = { userId: userId, clientId: clientId}
    return await api.getGmailLabels(body)
    .then(res => {
        const labels = res.data['labels']
        let options = {} 
        labels.map(labels => {
            options[labels['id']] = { title: prettyString(labels['name']), value: labels['id'] }
        })
        console.log('[getGmailLabels] Completed', options)
        return { success: true, options: options}
    })
    .catch(err => {
        console.log('[getGmailLabels] Failed', err)
        return { success: false, options: {} }
    })
}

export const getGmailMessages = async (payload) => {
    console.log('[getGmailMessages] payload', payload)

    const userId = payload['userId']
    const workflow = payload.workflow
    let labelId = workflow['trigger']['labelId']
    const trigger = workflow['trigger']['trigger']
    const clientId = workflow['trigger']['clientId']

    let filters
    switch(trigger) {
        case 'NewEmail':
            // Do nothing
            break
        case 'NewEmailMatch':
            // Construct filter
            filters = workflow['trigger']['ext'] && workflow['trigger']['ext']['match']
            break
        case 'NewLabeledEmail':
            // Do nothing
            break
        case 'NewStarredEmail':
            labelId = 'STARRED'
            break
    }

    const body = { userId: userId, clientId: clientId, labelId: labelId, filters: filters }
    return await api.getGmailMessage(body)
    .then(res => {
        console.log('[getEmailMessages] Completed', res.data)

        // Conntruct item
        const item = new Item({
            sectionID: workflow['action'].ext['sectionID'],
            pageID: workflow['action'].ext['pageID'],
            tags: workflow['action'].ext['tags'],
            priority: workflow['action'].ext['priority'],
            content: JSON.stringify(convertToRaw(ContentState.createFromText(res.data['message'][workflow.action.ext['title']]))),
            client: 'GMAIL',
            clientTitle: workflow.trigger.clientId
        })

        return { success: true, message: res.data['message'], items: [item] }
    })
    .catch(err => {
        console.log('[getGmailMessages] Failed', err)
        return { success: false, calendars: [] }
    })
}

//////////////
// TELEGRAM //
//////////////
export const testTelegram = async (payload) => {
    console.log('[testTelegram]', payload)
    const chatId = payload.action['clientId']
    const data = payload.data
    const message = genMessage(payload.workflow, data)
    return await api.sendTele(chatId, { message })
    .then(res => {
        console.log('[testTelegram] Completed')
        return { success: true }
    })
    .catch(err => {
        console.log('[testTelegram] Failed', err)
        return { success: false }
    })
}

export const genMessage = (workflow, data) => {
    const debug = false
    let components = ['<b>New item from Atomicly</b>']

    // Base components
    const itemTitle = 'Title: This is a dummy item'
    const pageTitle = 'Page: ' + data['pages'][workflow.trigger.ext['pageID']]['page_name']
    const sectionTitle = data['sections'][workflow.trigger.ext['sectionID']] && 'Section: ' + data['sections'][workflow.trigger.ext['sectionID']]['section_name']
    components.push(...[itemTitle, pageTitle, sectionTitle])

    // Optional components
    const tags = workflow.trigger.ext['tags'] && 'Tags: ' + workflow.trigger.ext['tags'].map(tagID => data['tags'][tagID]['content'][0].toUpperCase() + data['tags'][tagID]['content'].slice(1).toLowerCase()).join(', ')
    const scheduleTitle = ['ScheduleItem','StartScheduleItem'].includes(workflow.trigger['trigger']) && `Due: ${moment(new Date()).format("ddd, DD-MMM h:mm a")}`
    const priorityTitle = workflow.trigger.ext['priority'] && 'Priority: ' + workflow.trigger.ext['priority'][0] + workflow.trigger.ext['priority'].slice(1).toLowerCase()
    components.push(...[tags, scheduleTitle, priorityTitle].filter(x => x))
    debug && console.log({tags: tags, schedule: scheduleTitle, priority: priorityTitle})
    return components.join('\n')
}

export const genNotiMessage = (item, data, timezone) => {
    // Time to item
    const durationTitle = item['start_time'] ? `<b>Item starting in ${momentDate(item['start_time'], timezone, false).toNow()}</b>`
                    : item['end_time'] ? `<b>Item starting in ${momentDate(item['end_time'], timezone, false).toNow()}</b>`
                    : `<b>Item scheduled for today</b>`
    let components = [durationTitle]

    // Base components
    const itemTitle = `Title: ${getPlainText(item['content'])}`
    const pageTitle = 'Page: ' + data['pages'][item['pageID']]['page_name']
    const sectionTitle = data['sections'][item['sectionID']] && 'Section: ' + data['sections'][item['sectionID']]['section_name']
    components.push(...[itemTitle, pageTitle, sectionTitle])

    // Schedule
    const schedule = {
        start_date: item['start_date'],
        start_time: item['start_time'],
        end_date: item['end_date'],
        end_time: item['end_time']
    }
    const scheduleTitle = scheduleString(schedule, timezone, 'string')
    scheduleTitle && components.push(`Schedule: ${scheduleTitle}`)

    return components.join('\n')
}

////////////
// TRELLO //
////////////
export const getTrelloBoards = async(payload) => {
    const userId = payload['userId']
    let options = {}
    return await api.getTrelloBoards({userId})
    .then(res => {
        const boards = res.data['boards']
        boards.map(board => {
            options[board['id']] = { title: board['name'], value: board['id'] }
        })
        return { success: true, options: options }
    })
    .catch(err => {
        return { success: false, options: options }
    })
}

export const getTrelloLists = async(payload) => {
    const userId = payload['userId']
    const boardId = payload.trigger.ext['boardId']
    let options = {}
    return await api.getTrelloLists({ userId, boardId })
    .then(res => {
        const lists = res.data['lists']
        // Add any option
        if(lists.length > 0){
            options['ANY'] = { title: 'Any list', value: 'ANY' }
        }

        // Add remaining lists
        lists.map(list => {
            options[list['id']] = { title: list['name'], value: list['id'] }
        })
        return { success: true, options: options }
    })
    .catch(err => {
        return { success: false, options: options }
    })
}

export const getTrelloLabels = async(payload) => {
    const userId = payload['userId']
    const boardId = payload.trigger.ext['boardId']
    let options = {}
    return await api.getTrelloLabels({ userId, boardId })
    .then(res => {
        const labels = res.data['labels']
        labels.map(label => {
            options[label['id']] = { title: label['name'], value: label['id'] }
        })
        return { success: true, options: options }
    })
    .catch(err => {
        return { success: false, options: options }
    })
}

export const testTrello = async(payload) => {
    const debug = false
    debug && console.log('[testTrello]', payload)
    let items = []
    const userId = payload['userId']
    const workflow = payload['workflow']
    const boardId = workflow.trigger.ext['boardId']
    const listId = workflow.trigger.ext['listId']
    return api.getTrelloBoardCards({ userId, listId, boardId })
    .then(res => {
        debug && console.log('[testTrello]', res.data)
        res.data['cards'].map(card => {
            const item = new Item({
                sectionID: workflow['action'].ext['sectionID'],
                pageID: workflow['action'].ext['pageID'],
                tags: workflow['action'].ext['tags'],
                priority: workflow['action'].ext['priority'],
                content: JSON.stringify(convertToRaw(ContentState.createFromText(card[workflow.action.ext['title']]))),
                client: 'TRELLO',
                clientTitle: 'Trello'
            })
            items.push(item)
        })
        return { success: true, items: items}
    })
    .catch(err => {
        debug && console.log('[testTrello] Failed', err)
        return { success: false, items: items}
    })
}

////////////
// GSHEET //
////////////
export const gsheetOnNext = async(payload) => {
    const debug = false;
    // Need to return updatedState with errors and isValid
    debug && console.log('[gsheetOnNext] Input', payload)
    let updatedWorkflow = payload['workflow']
    let outcome = false
    let errors = { action: { ext: {} }, trigger: { ext: {} }}
    const regex = '(?<=spreadsheets\/d\/)(.*?)(?=\/edit)'
    const sheetId = updatedWorkflow.trigger.ext['sheetUrl'].match(regex) && updatedWorkflow.trigger.ext['sheetUrl'].match(regex)[0]

    return api.getSheet({
        userId: payload['userId'],
        clientId: updatedWorkflow.trigger['clientId'],
        sheetId: sheetId,
        rangeId: updatedWorkflow.trigger.ext['rangeId']
    })
    .then(sheetRes => {
        console.log(sheetRes)
        const sheet = sheetRes.data['sheet']
        const isSuccess = sheetRes.data['success']
        if(isSuccess){
            // Update workflow
            updatedWorkflow.trigger.ext['sheetId'] = sheetId

            // Check if columnId provided is valid
            const headers = sheet['values'][0]
            if(!headers.includes(updatedWorkflow.trigger.ext['idColumn'])){
                outcome = false
                errors.trigger.ext['idColumn'] = 'Column does not exist'
            } else {
                outcome = true
                updatedWorkflow.trigger.ext['headers'] = headers
            }
            
            debug && console.log('[gsheetOnNext] Outcome', { outcome: outcome, workflow: updatedWorkflow, errors: errors, sheet })
            return { outcome: outcome, workflow: updatedWorkflow, errors: errors }
        } else {
            errors.trigger.ext['sheetUrl'] = 'Invalid'
            errors.trigger.ext['rangeId'] = 'Invalid'

            debug && console.log('[gsheetOnNext] Outcome', { outcome: outcome, workflow: updatedWorkflow, errors: errors })
            return { outcome: outcome, workflow: updatedWorkflow, errors: errors }
        }
    })
    .catch(sheetErr => {
        console.log(sheetErr)
        const sheetErrors = sheetErr.response.data['errors']
        errors.trigger.ext['sheetUrl'] = sheetErrors['sheetId']
        errors.trigger.ext['rangeId'] = sheetErrors['rangeId']

        debug && console.log('[gsheetOnNext] Outcome', sheetErr.response['data'])
        return { outcome: outcome, workflow: updatedWorkflow, errors: errors }
    })
}

export const getGsheet = async(payload) => {
    const debug = false
    debug && console.log('[getGsheet]', payload)
    let options = {};
    let updatedWorkflow = payload['workflow']
    updatedWorkflow['trigger'] = payload['trigger']
    const regex = '(?<=spreadsheets\/d\/)(.*?)(?=\/edit)'
    if(!updatedWorkflow.trigger.ext['sheetUrl']){
        return { success: false, options: options }
    }
    const sheetId = updatedWorkflow.trigger.ext['sheetUrl'].match(regex) && updatedWorkflow.trigger.ext['sheetUrl'].match(regex)[0]
    
    return api.getSheet({
        userId: payload['userId'],
        clientId: payload.trigger['clientId'],
        sheetId: sheetId,
        rangeId: payload.trigger.ext['rangeId']
    })
    .then(sheetRes => {
        const sheet = sheetRes.data['sheet']
        const isSuccess = sheetRes.data['success']
        if(isSuccess){
            debug && console.log('[getGsheet] Outcome', sheet)
            const headers = sheet['values'][0]
            headers.map((header,index) => {
                options[index.toString()] = { title: header.toString(), value: index.toString()}
            })
            updatedWorkflow.trigger.ext['headers'] = headers

            return { success: true, options: options, workflow: updatedWorkflow }
        } else {
            debug && console.log('[getGsheet] Outcome')
            return { success: false, options: options, workflow: updatedWorkflow  }
        }
    })
    .catch(sheetErr => {
        debug && console.log('[getGsheet] Failed to get Gsheet', sheetErr)
        return { success: false, options: options, workflow: updatedWorkflow  }
    })
}

const formatGsheet = (sheet, workflow) => {
    const workflowId = workflow['workflowId']
    const sheetId = workflow.trigger.ext['sheetId']
    const idColumn = workflow.trigger.ext['idColumn']
    const headers = sheet.values[0]

    let rows = []
    let sheetItemIds = []
    sheet.values.slice(1).map(row => {
        let values = _.zipObject(headers, row)
        const clientItemId = `${workflowId}:${values[idColumn].toString()}:${sheetId}`
        values['atomiclyClientItemId'] = clientItemId
        values['sheetName'] = sheet['sheetName']
        values['rangeId'] = workflow.trigger.ext['rangeId']
        values['sheetURL'] = sheet['sheetURL']
        !sheetItemIds.includes(clientItemId) && rows.push(values)
    })
    return rows
}

const constructGsheetNotes = (raw, components) => {
    const debug = false
    let blocks = []

    // Base notes
    components.includes('sheetName') && blocks.push(`Sheet name: ${raw['sheetName']}`)
    components.includes('rangeId') && blocks.push(`Sheet range: ${raw['rangeId']}`)

    // Column notes
    components.map(component => {
        if(!['sheetName','rangeId'].includes(component)){
            raw[component] && blocks.push(`${component}: ${raw[component]}`)
        }
    })

    blocks.push(`Sheet URL [${raw['sheetURL']}]`)

    debug && console.log('[constructNotes] Output', blocks.join('\n'))
    return constructRichText(blocks.join('\n'))
}

const processGsheetFilters = (row, conditions, headers) => {
    let isMatch = false
    conditions.map(condition => {
        const operator = condition['operator']['value']
        const colIndex = parseInt(condition.option['value'])
        const column = headers[colIndex]
        const value = condition['value']

        if(['e','ne'].includes(operator)){
            if(operator === 'e'){
                if(value === row[column]) { 
                    isMatch = true 
                } else {
                    isMatch = false
                }
            } else if (operator === 'ne'){
                if(value === row[column]) { 
                    isMatch = true 
                } else {
                    isMatch = false
                }
            }
        } else if (['in','ne'].includes(operator)){
            if(operator === 'in'){
                if(value.includes(row[column])) { 
                    isMatch = true 
                } else {
                    isMatch = false
                }
            } else if (operator === 'ne'){
                if(!value.includes(row[column])) { 
                    isMatch = true 
                } else {
                    isMatch = false
                }
            }
        }
    })
    return isMatch
}

export const testGsheet = async(payload) => {
    const debug = false;
    let items = [];
    debug && console.log('[testGsheet]', payload)
    const workflow = payload['workflow']

    return await api.getSheet({
        userId: workflow['userId'],
        clientId: workflow.trigger['clientId'],
        sheetId: workflow.trigger.ext['sheetId'],
        rangeId: workflow.trigger.ext['rangeId']
    })
    .then(sheetRes => {
        const sheet = sheetRes.data['sheet']
        const isSuccess = sheetRes.data['success']
        const headers = sheet.values[0]

        if(isSuccess){
            const gsheet = formatGsheet(sheet, workflow)
            const trigger = workflow.trigger['trigger']
            const validRows = trigger === 'NewRow' ? gsheet
                            : trigger === 'FilterRow' ? gsheet.filter(row => processGsheetFilters(row, workflow.trigger.ext['conditions'],headers))
                            : gsheet
            debug && console.log('[testGhseet] Valid rows', validRows)
            if(validRows.length > 0){
                validRows.map(row => {
                    const item = new Item({
                        pageID: workflow.action.ext['pageID'],
                        sectionID: workflow.action.ext['sectionID'],
                        tags: workflow.action.ext['tags'],
                        priority: workflow.action.ext['priority'],
                        content: constructRichText(row[workflow.action.ext['title']]),
                        notes: constructGsheetNotes(row, workflow.action.ext['notes']),
                        client: 'GSHEET',
                        clientId: workflow.trigger['clientId'],
                        clientItemId: row['atomiclyClientItemId'],
                    })
                    items.push(item)
                })
            }
            debug && console.log('[testGsheet] Got Gsheet', {sheet, gsheet})
            return { success: items.length > 0, items: items }
        } else {
            debug && console.log('[testGsheet] Outcome')
            return { success: false, items: items }
        }
    })
    .catch(sheetErr => {
        debug && console.log('[testGsheet] Failed to get Gsheet', sheetErr)
        return { success: false, items: items }
    })
}

/////////////
// TODOIST //
/////////////
export const getTodoistProjects = async(payload) => {
    const debug = false;
    debug && console.log('[getProjects]', payload)
    const userId = payload['userId']
    const trigger = payload['trigger']

    let options = {}
    return api.getTodoistResource({ 
        userId: userId,
        clientId: trigger['clientId'],
        resourceType: 'projects'
    })
    .then(projectsRes => {
        let projects = projectsRes.data['resource'] && projectsRes.data['resource']['projects']
        projects = projects.filter(project => project['is_archived'] !== 1 && project['is_deleted'] !== 1)
        projects.map(project => {
            options[project['id']] = { title: project['name'], value: project['id'] }
        })

        debug && console.log('[getProjects] Got projects', {projects, options})
        return { success: true, options: options }
    })
    .catch(projectsErr => {
        debug && console.log('[getProjects] Failed to get projects')
        return { success: false, options: options }
    })
}

export const getTodoistSections = async(payload) => {
    const debug = false;
    debug && console.log('[getSections]', payload)
    const userId = payload['userId']
    const trigger = payload['trigger']
    const projectId = trigger.ext['projectId']

    let options = {
        ANY: { title: 'Any Section', value: 'ANY' }
    }
    const res = await api.getTodoistResource({ 
        userId: userId,
        clientId: trigger['clientId'],
        resourceType: 'sections'
    })
    .then(sectionsRes => {
        console.log(sectionsRes)
        let sections = sectionsRes.data['resource'] && sectionsRes.data['resource']['sections']
        sections = sections.filter(section => !section['is_archived'] && !section['is_deleted'] && section['project_id'] === projectId)
        sections.map(section => {
            options[section['id']] = { title: section['name'], value: section['id'] }
        })

        debug && console.log('[getSections] Got sections', {sections, options})
        return { success: true, options: options }
    })
    .catch(sectionsErr => {
        debug && console.log('[getSections] Failed to get sections')
        return { success: false, options: options }
    })
    return res
}

export const getTodoistLabels = async(payload) => {
    const debug = false;
    debug && console.log('[getLabels]', payload)
    const userId = payload['userId']
    const trigger = payload['trigger']

    let options = {}
    return api.getTodoistResource({ 
        userId: userId,
        clientId: trigger['clientId'],
        resourceType: 'labels'
    })
    .then(labelsRes => {
        let labels = labelsRes.data['resource'] && labelsRes.data['resource']['labels']
        labels = labels.filter(section => section['is_deleted'] !== 1)
        labels.map(label => {
            options[label['id']] = { title: label['name'], value: label['id'] }
        })

        debug && console.log('[getLabels] Got labels', {labels, options})
        return { success: true, options: options }
    })
    .catch(sectionsErr => {
        debug && console.log('[getLabels] Failed to get labels')
        return { success: false, options: options }
    })
}

export const testTodoist = async(payload) => {
    const debug = true;
    let items = []
    const workflow = payload['workflow']
    debug && console.log('[testTodoist]', payload)

    return await api.getTodoistProjectData({
        userId: workflow['userId'],
        clientId: workflow.trigger['clientId'],
        projectId: workflow.trigger.ext['projectId']
    })
    .then(projectRes => {
        const data = projectRes.data['project']
        const tasks = data['items']
        debug && console.log('[testTodoist] Got project', {items})
        const trigger = workflow.trigger['trigger']
        const validTasks = trigger === 'NewTask' ? tasks
                        : trigger === 'TaskScheduled' ? tasks.filter(task => task['due'])
                        : trigger === 'TaskLabelled' ? tasks.filter(task => _.difference(workflow.trigger.ext['labelIds'], task['labels']).length === 0)
                        : []
        validTasks.length > 0 && validTasks.map(task => {
            const item = new Item({
                end_time: task['due'] && task['due']['string'].length > 6 ? task['due']['date'] : null,
                start_date: task['due'] && task['due']['date'],
                end_date: task['due'] && task['due']['date'],
                pageID: workflow.action.ext['pageID'],
                sectionID: workflow.action.ext['sectionID'],
                tags: workflow.action.ext['tags'],
                priority: workflow.action.ext['priority'],
                content: constructRichText(task[workflow.action.ext['title']]),
                client: 'TODOIST',
                clientId: workflow.trigger['clientId'],
                clientItemId: task['id'],
            })
            items.push(item)
        })
        return { success: items.length > 0, items: items }
    })
    .catch(projectErr => {
        debug && console.log('[testTodoist] Failed to get project')
        return { success: false, items: items }
    })
}

//////////////////////
// OUTLOOK CALENDAR //
//////////////////////
export const getOutlookCalendars = async(payload) => {
    console.log('[getOutlookCalendars] payload', payload)

    const userId = payload['userId']
    const clientId = payload.trigger['clientId']
    const body = { userId: userId, clientId: clientId}
    return await api.getOutlookCalendars(body)
    .then(res => {
        const calendars = res.data['calendars']
        let options = {} 
        calendars.map(calendar => {
            options[calendar['id']] = { title: calendar['name'], value: calendar['id'] }
        })
        console.log('[getOutlookCalendars] Completed', options)
        return { success: true, options: options }
    })
    .catch(err => {
        console.log('[getOutlookCalendars] Failed', err)
        return { success: false, options: {} }
    })
}

export const getOutlookCalendarEvents = async(payload) => {
    console.log('[getOutlookCalendarEvents]')
    const debug = true;
    const userId = payload['userId']
    const clientId = payload.workflow.trigger['clientId']
    const calendarId = payload.workflow.trigger.ext['calendarId']
    const n = payload['n'] || 5
    const workflow = payload.workflow
    const trigger = workflow['trigger']['trigger']
    const body = { userId, clientId, calendarId, n }

    return await api.getOutlookCalendarEvents(body)
    .then(res => {
        const events = res.data['events']

        // Convert events into items
        let items = []
        events.map(event => {
            const item = new Item({
                sectionID: workflow['action'].ext['sectionID'],
                pageID: workflow['action'].ext['pageID'],
                tags: workflow['action'].ext['tags'],
                priority: workflow['action'].ext['priority'],
                content: JSON.stringify(convertToRaw(ContentState.createFromText(event[workflow['action'].ext['title']]))),
                client: 'OUTLOOK_CALENDAR',
                clientTitle: workflow.trigger.clientTitle
                // No need notes because its not being shown in the preview
        })
            const isMatch = workflow['trigger'].ext['match'] && event['subject'].includes(workflow['trigger'].ext['match'])
            const isAccepted = ['organizer','tentativelyAccepted','accepted'].includes(event['response'])
            // console.log(isMatch, {workflow: workflow, event: event})
            switch(trigger){
                case 'NewEvent':
                    // Do nothing
                    items.push(item)
                    break
                case 'NewEventMatch':
                    // First event that matches
                    isMatch && items.push(item)
                    break
                case 'AcceptedEvent':
                    // First accepted event
                    isAccepted && items.push(item)
                    break
                case 'AcceptedEventMatch':
                    // First accepted event that matches
                    isMatch & isAccepted && items.push(item)
                    break
            }
        })
        console.log('[getOutlookCalendarEvents]', {events, items})
        return { success: items.length > 0, events: events, items: items }

    })
    .catch(err => {
        return { success: false, events: [], items: [] }
    })
}